<pcp-slide-sync-toolbar-button
        [matIcon]="icon"
        [fontSet]="fontSet"
        (toggle)="toggle()"
        [turnedOn]="(isActivated$ | async) === true"
        [disabled]="(isDisabled$ | async) === true"
></pcp-slide-sync-toolbar-button>
